import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls the given scrollable container back to the top on every route change.
// The app's actual scrolling happens inside a nested <main> (overflow-y: auto in
// Layout.js), not the window/document, so plain window.scrollTo() wouldn't move
// anything visible - it has to target that container directly.
export function useScrollToTop(containerRef) {
  const { pathname } = useLocation();

  useEffect(() => {
    containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname, containerRef]);
}
